import { OpenSansText } from "@Components/CustomText/OpenSansText"
import Modal from "react-native-modal"
import { Spacer } from "@Components/Space"
import React, { useEffect, useState } from "react"
import { Dimensions, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native"
import { QuestionCard } from "./QuestionCard"
import { IconButton } from "react-native-paper"
import { MultilineInput } from "@Components/Input/MutlilineInput"
import { Button, ButtonGreenDark, CardButtonGreenDark } from "@Components/CustomButton/Button"
import { baseColors, dimensions } from "@Constants/baseStyles"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import { canGotoNextAtom, surveyResponsesAtom } from "@Recoil/Atom/surveyAtom"
import { isNumber } from "@Utils/utils"
import { currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import SvgDinerIcon from "@Components/CustomIcon/SvgDinerIcon"
import SvgCollationIcon from "@Components/CustomIcon/SvgCollationIcon"
import SvgDejeunerIcon from "@Components/CustomIcon/SvgDejeunerIcon"
import SvgCoffeIcon from "@Components/CustomIcon/SvgCoffeIcon"
import {
    cardItemPrecision,
    handlePreselectCardFromSavedResponse,
    handlePressCard,
    handleSetCardPrecision,
    handleSetResponseGlobal
} from "./Question.utils"
import { ParentSurveyContent } from "./ParentSurveyContent"
import { SALUTANCE } from "@Services/AxiosInstance"
import { MaterialCommunityIcons } from "@expo/vector-icons"

const { width } = Dimensions.get("screen")

const twoByTwo = (original) => {
    let grouped = []

    grouped = original.reduce(function (accumulator, currentValue, currentIndex, array) {
        if (currentIndex % 2 === 0) accumulator.push(array.slice(currentIndex, currentIndex + 2))
        return accumulator
    }, [])
    return grouped
}

const getIcon = (type, active) => {
    switch (type) {
        case "DINNER":
            return <SvgDinerIcon fill={active ? baseColors.white : baseColors.green.primary} />
        case "MORNING_SNACK":
            return <SvgCollationIcon fill={active ? baseColors.white : baseColors.green.primary} />
        case "LUNCH":
            return <SvgDejeunerIcon fill={active ? baseColors.white : baseColors.green.primary} />
        case "AFTERNOON_SNACK":
            return <SvgCollationIcon fill={active ? baseColors.white : baseColors.green.primary} />
        default:
            return <SvgCoffeIcon fill={active ? baseColors.white : baseColors.green.primary} />
    }
}

export const QuestionWithCard = (props) => {
    const {
        axisId,
        surveyId,
        responseTypeId,
        hasPrecision,
        question,
        color,
        isChildren,
        questionNumber,
        proposalAnswer,
        userResponse,
        hasResponse,
        precisionText,
        disabled,
        isParent,
        parentLabel,
        isFirstQuestion
    } = props

    const defaultResponse = {
        axisId: axisId,
        surveyId: surveyId,
        responseTypeId: responseTypeId,
        responseValue: "",
        hasPrecision: hasPrecision,
        precisionAnswer: ""
    }

    const [response, setResponse] = useState(defaultResponse)
    const [responseGlobal, setResponseGlobal] = useRecoilState(surveyResponsesAtom)
    const [choosed, setChoosed] = useState(response.responseValue ?? 0)
    const [selectedCards, setSelectedCards] = useState([])
    const [precision, setPrecision] = useState("")
    const [modalVisible, setModalVisible] = useState(false)
    const grouped = twoByTwo(proposalAnswer)
    const currentEducationalDiagnosis = useRecoilValue(currentDiagnosisAtom)
    const [modalTitle, setModalTitle] = useState("")
    const setCanGoToNext = useSetRecoilState(canGotoNextAtom)

    useEffect(() => {
        if (isNumber(choosed) && !hasResponse && !disabled) {
            handleSetResponseGlobal({ response, selectedCards, setResponseGlobal, responseGlobal, surveyId })
        }
    }, [selectedCards, choosed, surveyId, response, precision, disabled])

    useEffect(() => {
        if (responseGlobal[surveyId] && !hasResponse && !disabled) {
            handlePreselectCardFromSavedResponse({ responseGlobal, surveyId, setSelectedCards })
        }
    }, [hasResponse, surveyId, disabled])

    useEffect(() => {
        if (responseGlobal?.[surveyId] && responseGlobal[surveyId]?.responseItems?.length === 0) {
            setCanGoToNext?.(false)
            setChoosed(0)

            setResponseGlobal((prev) => {
                let prevResponse = prev
                delete prevResponse[surveyId]
                return { ...prevResponse }
            })
        }
    }, [responseGlobal])

    useEffect(() => {
        if (userResponse?.id > 0 && currentEducationalDiagnosis?.id > 0) {
            // setChoosed(+userResponse?.response)
        }
    }, [userResponse])

    const handleSetChoice = (val) => {
        handlePressCard({ selectedId: val, setSelectedIds: setSelectedCards })
        setCanGoToNext?.(true)
    }

    useEffect(() => {
        setCanGoToNext(() => {
            const hasNoResponse = responseGlobal?.[surveyId] && responseGlobal[surveyId]?.responseItems?.length === 0
            const hasCard = selectedCards?.length > 0 && hasNoResponse

            if (choosed > 0 || hasCard) {
                return true
            }

            return false
        })
    }, [choosed, selectedCards, responseGlobal])

    if (isParent) {
        return <ParentSurveyContent question={question} />
    }

    return (
        <View style={{ padding: 20 }}>
            {isFirstQuestion && (
                <>
                    <OpenSansText fontSize={14} style={{}} color={baseColors.black}>
                        {parentLabel ?? ""}
                    </OpenSansText>

                    <Spacer />
                </>
            )}

            <OpenSansText color={color}>
                {SALUTANCE ? "QUESTION : " : !isChildren ? `QUESTION N° ${questionNumber}` : ""}
            </OpenSansText>

            <Spacer />

            <OpenSansText fontSize={14} style={{ textDecorationLine: "underline" }} color={baseColors.green.dark}>
                {question}
            </OpenSansText>

            <Spacer />

            {/* <ScrollView
                keyboardShouldPersistTaps={"handled"}
                showsHorizontalScrollIndicator={false}
                horizontal={true}
                style={{ height: 170 }}
                snapToAlignment={"center"}
                scrollEventThrottle={16}
                centerContent
                bounces={false}
                contentContainerStyle={styles.contentContainerStyle}
            > */}
            {grouped.map((item, index) => {
                return (
                    <View key={index} style={styles.rowContainer}>
                        {item?.map((itm, indx) => {
                            const active = selectedCards?.includes(itm.proposalAnswer.id)

                            return (
                                <QuestionCard
                                    disabled={disabled}
                                    onPress={() => {
                                        handleSetChoice(itm.proposalAnswer.id)
                                        setChoosed(itm.proposalAnswer.id)
                                        setModalVisible(true)
                                        setModalTitle(`${itm?.proposalAnswer?.name} (${precisionText})`)
                                    }}
                                    key={indx}
                                    title={itm?.proposalAnswer?.name}
                                    active={active}
                                    icon={getIcon(itm.proposalAnswer?.code, active)}
                                    precision={cardItemPrecision({
                                        precision,
                                        cardId: itm.proposalAnswer.id,
                                        responseGlobal: responseGlobal[surveyId]
                                    })}
                                />
                            )
                        })}
                    </View>
                )
            })}
            {/* </ScrollView> */}

            <View>
                <Modal
                    isVisible={modalVisible}
                    onModalHide={() => {
                        const removeCardWithEmptyPrecision = responseGlobal?.[surveyId]?.responseItems?.filter(
                            (item) => item?.responseValue != choosed
                        )

                        if (precision?.trim() === "") {
                            setSelectedCards((prev) => prev?.filter((item) => item !== choosed))
                            setResponseGlobal((prevResGlobal) => ({
                                ...prevResGlobal,
                                [surveyId]: {
                                    ...prevResGlobal[surveyId],
                                    responseItems: removeCardWithEmptyPrecision ?? []
                                }
                            }))
                        }
                    }}
                    onModalShow={() => {
                        const selectedCardPrecision = responseGlobal?.[surveyId]?.responseItems?.find(
                            (item) => item?.responseValue === choosed
                        )
                        setPrecision(selectedCardPrecision?.precisionAnswer ?? "")
                    }}
                >
                    <View style={styles.modalContainer}>
                        {/* <IconButton
                            rippleColor={"rgba(0,0,0,0.05)"}
                            onPress={() => setModalVisible(false)}
                            icon="close"
                            color={baseColors.green.primary}
                            size={35}
                            style={{ alignSelf: "flex-end" }}
                        /> */}

                        <TouchableOpacity
                            onPress={() => setModalVisible(false)}
                            style={{ alignSelf: "flex-end", padding: 20 }}
                        >
                            <MaterialCommunityIcons name={"close"} size={35} color={baseColors.green.primary} />
                        </TouchableOpacity>

                        <ScrollView contentContainerStyle={{ paddingBottom: 30 }} style={{ paddingHorizontal: 20 }}>
                            <OpenSansText fontSize={14}>{modalTitle}</OpenSansText>
                            <Spacer height={20} />
                            <MultilineInput
                                value={precision}
                                onChange={(text) => {
                                    handleSetCardPrecision({
                                        choosed,
                                        response,
                                        precisionAnswer: text,
                                        setResponseGlobal,
                                        surveyId
                                    })
                                    setPrecision(text)
                                }}
                                height={70}
                            />
                        </ScrollView>
                        <Button
                            {...CardButtonGreenDark}
                            onPress={() => {
                                setModalVisible(false)
                            }}
                        />
                        <Spacer />
                    </View>
                </Modal>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    rowContainer: {
        flexDirection: "row",
        justifyContent: "space-around",
        flex: 1
    },
    contentContainerStyle: {
        flexGrow: 1,
        justifyContent: "center",
        alignItems: "center"
    },
    modalContainer: {
        borderRadius: 20,
        backgroundColor: "white",
        height: Math.round(dimensions.fullHeight) / 2.5,
        width: width - 40
    }
})
